











































































import Vue from "vue";
import BankExtractImportApi from "../services/BankExtractImportApi";
import store from "../services/BankExtractImportStore";
import BankExtractImport from "../models/BankExtractImport";
import BankExtractImportItem from "../models/BankExtractImportItem";
import pStore, { PartnerStore } from "../../partner/services/PartnerStore";
import eventBus from "@/services/eventBus";
import { t } from "@/plugins/i18n";

export default Vue.extend({
  components: {  },

  props: {
    item: { type: Object as () => BankExtractImportItem } 
  },

  data: () => ({
    store,
    pStore,
    loaded: false,
    selectedBank: 1,
    accountNumber: '',
    isIban: false,
    currency: '',
    native: true,
  }),

  async beforeMount() {
    await this.store.loadBanks();
    await this.pStore.loadCurrencies();

    if (this.item.iban) {
      this.accountNumber = this.item.iban;
      this.isIban = true;
    } else {
      this.isIban = false;
      
      if (this.item.accountWith == null) {
        this.item.accountWith = '';
      }

      if (this.item.accountNumber == null) {
        this.item.accountNumber = '';
      }

      this.accountNumber = this.formatBankszamla(this.item.accountWith.replaceAll('-', '') + this.item.accountNumber.replaceAll('-', ''));
    }

    this.loaded = true;
  },

  methods: {
    async save() {
      await BankExtractImportApi.createPartBank(
        this.item.id,
        this.isIban ? this.accountNumber : '',
        !this.isIban ? this.accountNumber : '',
        this.item.partnerID,
        this.selectedBank,
        this.currency,
        this.native
      );

      eventBus.$emit("success", t("BankExtract_SikeresenLetrehozva"));

      this.item.partBankCreate = false;
    },

    cancel(){
      this.item.partBankCreate = false;
    },

    formatBankszamla(szam: string) {
    // 1. Eltávolítunk minden nem szám karaktert
    const tisztitott = szam.replace(/\D/g, '');

    // 2. Csoportosítjuk 8 számjegyenként, és kötőjelet teszünk közéjük
    // Ez kezeli a 16 és a 24 jegyű számlaszámokat is
    return tisztitott.replace(/(\d{8})(?=\d)/g, '$1-');
}
  }
});
